// extracted by mini-css-extract-plugin
module.exports = {"container":"credit_container__3SxNT","inner":"credit_inner__1MJjY"};